var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDialogIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 459,
    y: 233,
    width: 56,
    height: 50
  })), /*#__PURE__*/React.createElement("image", {
    width: 30,
    height: 29,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAyCAMAAAA+w+hKAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKIUExURQAAAAD//wDJvADLtwDOvADNwQDGuACqqgDMvwLOvgHPvQHOvgHOvgHOvgHPvwHPvgHQvgLRvADPvwC/vwDb2wPNwAHSwQHYxwHbyQHWxAHWxQHVxAHayQHYxQHOvQDPvgDTvADPvgHUwwHZyAHRwAHPvgHQvwHYxgHSwQLPvgDZvwDKuQHWxAHYxwHSwQHUwwHTwgHTwwHOvQHTwgDQvgD/qgHPvwHQvgHQwAHOvQHOvgHPvgHPvwHPvgHRwQHizwDXxgDNvwDQvgHTwAHTwQLRvgDNuwDOuADLuwDTwgDSvgLRvgHRvwHSwAHPvQHZxwDSwALQvwHQwADTwgDOugHTwgHXxgHdywDUwADEsQLQvQHRwAHfzADUwwHSwAHXxQHk0gDYxwDMuwLQvgHRwAHayADTwQDPuQCAgAAAAADTwQHSwQHi0ADXxADMqgLPvAHOvgDRwADPwQDSvwDOwgDQwwDOvgHOvgHaxwHPvwHSwAHTwAHQvwHPvgHgzQDXxQDOtQDPrwD/AALNvQHhzwDWxQLOvQHRvwHRvwDWxgDPvwLQvQDYxwDXxgLQvgHRwADYxgLNvQHj0QDZxgDOvAHSvwHTwQHbyAHSwQDLvwDSwwHOvgHSwgHUwgDTwQDRvwDGqgC/vwHTwQHTwgDOvQDOvQLNvAHRvwHcyQDSwQDKvADOvgHSwQHQvwHPvgDPvQDOvQDNwADNvQDMvAHQvQDTwQDItgDIvAHSwAHUwgDKwADOvgHUwgHTwgDV1QTLugLQvgHRwAHZxwHbyAHaxwHZxwHcygHUwgHPvgDLvwCA/wDMswDOvwDRwADPvgDOvQDOvADNvADNvADOvwDNvADbyACAvwDMzFauvAIAAADYdFJOUwABEycqKRIDKHKvzNDPz8+0hTAEB2HK+////////+F6F2rn///////6hhQ60f///v7+/+ZWA6v/+eTb29rf9v+yJCvK/aVHLzEuM5rz////2IP2zDTA//+CDYz6/7Kv//+ID4n5/9JFAgEpyP+HD4r/11soKiZOx//8+fj7/v+RHxABkP+JiPj/ihCIiYeN+4qO/4dj5v//vSwRsf//+m8JDLn/mx+J8P/INZj9/NGEbXFsfsKhHBe3zjU/ydsGO57q/vz8/P7stEACCkRphpKRlIpzTA4EBS4Zt3kAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHqSURBVEhLY2AYYYCREEDXAAaMjEzMLKz4AAsLGzsWvRycXNw8vPgAH7+AoJAwmjYRUTFxCUlJKXxAUlpGVk5eAVWjopKyiiphoKauoamFrE9bRxcioadvgB0YGqiBFBjpGpuYImk0kzQHCetZWFpZYwc2tnZgJxnZOzgi9Dk5S4EEVVxc3dw9sANPL28fX1VVVT//ADeExsAgkGlGEsEhCDEMoBAaBvZOeEQkXCwqGqwxJhbJFZggLh7s1oTEJLhQcgpYY2paegau5JPJkJUtCdaYk5sH15gP1qhaEF9YVFzihBWUlpWrQcIVi0ZVVZV4/wocQF0PogS7RiIA9TRWVhEBqmtq0TXW1TdENhIETc0Waqga1VpaEbGDB7S1d6Br7OxCUYEDdI9qxA1GNeIBoxrxACwae4jSCMrIvQiNff1qLROI0jixRm3SZERZMWXqtOkzZqKowA5mzZ4zd978BXD+wkXqaouXLGVgxw8YI5ctV1mxchWSSavXqPiuXbd+w0Z8YNPmLe2+auFbtyFp3L4jXkVNT83IDx+oVdVTUZPYuQtJHwPD7j1hi1XNCQFVFZm9JvtQNDLsP3Dw0OEjeMHRI8eOnzh5ClUfA8PpM2fPnb+AD1y8dPnKVXRtYJAhfA0fuI6unr4AAD+xnw5UaFsvAAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 285790,
    height: 276264
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-459 -233)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.000104972 0 0 0.000104972 459 233)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    transform: "matrix(1 0 0 1 -0.233103 -0.0286154)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img1",
    transform: "scale(9526.32 9526.32)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogIcon);
export default __webpack_public_path__ + "static/media/dialogIcon.47d51dfcaef4faa7d6bb5ee1f6b8eeba.svg";
export { ForwardRef as ReactComponent };